import { LocationInstallationGroup } from '@core/models/location.model';

// The location's own groups and the groups of each feeding device overlap, so a group is listed once.
export function mergeInstallationGroups(
  lists: LocationInstallationGroup[][],
): LocationInstallationGroup[] {
  const groups = new Map<string, LocationInstallationGroup>();
  for (const group of lists.flat()) {
    if (!groups.has(group.installationGroupOid)) {
      groups.set(group.installationGroupOid, {
        installationGroupOid: group.installationGroupOid,
        name: group.name,
      });
    }
  }
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name));
}
